import script from "./contactInfoCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./contactInfoCheck.vue?vue&type=script&setup=true&lang=js"

import "./contactInfoCheck.vue?vue&type=style&index=0&id=2f315099&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f315099"]])

export default __exports__